// This function strips the whitespace before and after the value
export const normalizeText = (value: string): string => {
  if (!value) return value;
  return value.trim();
};
